var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.loading
        ? [
            _c("div", { staticClass: "loading-container" }, [
              _c("p", [_vm._v(_vm._s(_vm.$t("surveys.loading")))])
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.isSurveyAccessible
        ? [
            _c("SurveyTemplate", {
              attrs: {
                surveyTitle: _vm.surveyTitle,
                surveyId: _vm.surveyId,
                items: _vm.surveyItems,
                fromDialog: _vm.fromDialog
              },
              on: {
                surveyCompleted: _vm.handleSurveyCompleted,
                surveyStepChanged: _vm.handleSurveyStepChanged,
                surveyStarted: _vm.handleSurveyStarted,
                surveyLoaded: _vm.handleSurveyLoaded
              }
            })
          ]
        : _vm._e(),
      _vm._v(" "),
      !_vm.isSurveyAccessible && !_vm.loading
        ? [
            _c("div", { staticClass: "survey-unavailable" }, [
              _c("h3", [_vm._v(_vm._s(_vm.$i18n.t("surveys.not-avaliable")))]),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.$i18n.t("surveys.not-allowed")))])
            ])
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-404b7273", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-404b7273","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/surveys/SurveyTest.vue
// module id = 3048
// module chunks = 38 58